const txteng18 = [
  ["Я оправился от этого (потрясения)", "I've gotten over it."],
  [
    "Поверь мне, ты забудешь его (справишься с расставанием)",
    "Believe me, you'll get over him.",
  ],
  ["Время лечит все раны", "Time heals all wounds"],
  ["Джек сейчас выздоравливает после гриппа.", "Jake is getting over the flu."],
  ["Я выздоравливаю после простуды.", "I'm getting over my cold."],
  ["ты выздоравливаешь после болезни", "You're getting over your sickness."],
  ["Я выздоровел", "I'm right as rain again."],
  ["Я привык есть в 3 часа", "I got used to eating at three o'clock"],
];

export default txteng18;
